// import React from 'react'

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

export const TRIAS_SELECTED_WEB3_CONTEXT = 'TRIAS_SELECTED_WEB3_CONTEXT'

export const ANTIMATTER_TRANSACTION_LIST = 'ANTIMATTER_TRANSACTION_LIST'

export const CLEAR_ANTIMATTER_TRANSACTION_LIST =
    'CLEAR_ANTIMATTER_TRANSACTION_LIST'

export const HANDLE_POPUP_LIST = 'HANDLE_POPUP_LIST'

export const THIS_CHAIN_ID = 56;
